import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DispatchExutoireDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-dispatch-exutoire',
  templateUrl: './dispatch-exutoire.component.html',
  styleUrls: ['./dispatch-exutoire.component.css']
})
export class DispatchExutoireComponent implements OnInit {
  @Select(ControlPanelStore.dispatchExutoires$) dispatchExutoires$: Observable<DispatchExutoireDto[]>;

  private _dispatchExutoireId: number = null;
  DispatchExutoires: DispatchExutoireDto[] = [];

  @Input()
  get dispatchExutoireId() {
    return this._dispatchExutoireId;
  }
  set dispatchExutoireId(val) {
    this._dispatchExutoireId = val;
    this.getDispatchExutoireInComponent();
  }

  DispatchExutoireInComponent: string;

  dt: Subscription;

  constructor() { }

  ngOnInit() {
    this.dt = this.dispatchExutoires$.subscribe(res => {
      if (res != null) {
        this.DispatchExutoires = res;
        this.getDispatchExutoireInComponent();
      }
    });
  }

  getDispatchExutoireInComponent() {
    let dispatchExutoire = this.DispatchExutoires.find(p => p.Id == this.dispatchExutoireId);
    this.DispatchExutoireInComponent = (dispatchExutoire) ? dispatchExutoire.Identifiant : null;
  }

  ngOnDestroy() {
    this.dt?.unsubscribe();
  }

}
